"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarModalBody = CarModalBody;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../../View/Modals/FormContext");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
function CarModalBody({ isEditing, initialData }) {
    const { register, reset, formState: { errors }, trigger, } = (0, FormContext_1.useFormContext)();
    (0, react_1.useEffect)(() => {
        const resetData = {
            brand: initialData?.brand ?? "",
            model: initialData?.model ?? "",
            licensePlateNumber: initialData?.licensePlateNumber ?? "",
            mileageSpreadsheetId: initialData?.mileageSpreadsheetId ?? "",
            mileageSheetGid: initialData?.mileageSheetGid ?? "",
            // Nowe auto domyślnie aktywne - inaczej po dodaniu znikałoby z listy.
            isActive: initialData?.isActive ?? true,
            comment: initialData?.comment ?? "",
        };
        reset(resetData);
        trigger();
    }, [initialData, reset]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 6, controlId: "brand" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Marka"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "np. Ford", isInvalid: !!errors?.brand, ...register("brand") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "brand", errors: errors })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 6, controlId: "model" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Model"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "np. Focus", isInvalid: !!errors?.model, ...register("model") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "model", errors: errors }))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "licensePlateNumber", className: "mt-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Numer rejestracyjny"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "np. OP 1001A", isInvalid: !!errors?.licensePlateNumber, ...register("licensePlateNumber") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "licensePlateNumber", errors: errors }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Musi by\u0107 unikalny. Zapisywany wielkimi literami.")),
        react_1.default.createElement("hr", null),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 8, controlId: "mileageSpreadsheetId" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Arkusz kilometr\u00F3wki"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Identyfikator arkusza Google", isInvalid: !!errors?.mileageSpreadsheetId, ...register("mileageSpreadsheetId") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "mileageSpreadsheetId", errors: errors })),
            react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 4, controlId: "mileageSheetGid" },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Numer zak\u0142adki"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "np. 118273", isInvalid: !!errors?.mileageSheetGid, ...register("mileageSheetGid") }),
                react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "mileageSheetGid", errors: errors }))),
        react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Bez obu tych p\u00F3l auto nie pojawi si\u0119 w kilometr\u00F3wce, nawet je\u015Bli jest aktywne."),
        react_1.default.createElement("hr", null),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "isActive" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", label: "Aktywny", ...register("isActive") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { muted: true }, "Wycofanie auta z u\u017Cytku to wy\u0142\u0105czenie tej opcji, nie usuni\u0119cie wpisu - historia przejazd\u00F3w w arkuszu zostaje nienaruszona.")),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "comment", className: "mt-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Uwagi"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 2, isInvalid: !!errors?.comment, ...register("comment") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "comment", errors: errors }))));
}
